import api from "../middlware/api";
import { BASE_URL } from "../constants";

export const getStockTransfers = (params?: Record<string, any>) => {
  return new Promise((resolve, reject) => {
    const query = new URLSearchParams();
    if (params) {
      for (const key in params) {
        if (params[key] !== undefined && params[key] !== null && params[key] !== "") {
          query.set(key, String(params[key]));
        }
      }
    }
    const qs = query.toString();
    api
      .get(qs ? `${BASE_URL}/api/v1/stock-transfers?${qs}` : `${BASE_URL}/api/v1/stock-transfers`)
      .then((res) => resolve(res.data))
      .catch(reject);
  });
};

export const getStockTransferById = (id: number) => {
  return new Promise((resolve, reject) => {
    api
      .get(`${BASE_URL}/api/v1/stock-transfers/${id}`)
      .then((res) => resolve(res.data))
      .catch(reject);
  });
};

export const createStockTransfer = (payload: any) => {
  return new Promise((resolve, reject) => {
    api
      .post(`${BASE_URL}/api/v1/stock-transfers`, payload)
      .then((res) => resolve(res.data))
      .catch(reject);
  });
};

export const completeStockTransfer = (id: number, payload?: { transfer_date?: string }) => {
  return new Promise((resolve, reject) => {
    api
      .patch(`${BASE_URL}/api/v1/stock-transfers/${id}/status`, {
        status: "completed",
        ...(payload || {}),
      })
      .then((res) => resolve(res.data))
      .catch(reject);
  });
};
